// extracted by mini-css-extract-plugin
export default {"PrimaryNavbar":"PrimaryNavbar_PrimaryNavbar__MywDa","PrimaryNavbarContent":"PrimaryNavbar_PrimaryNavbarContent__kfOgp","LogoShort":"PrimaryNavbar_LogoShort__MI+w+"};